<template>
	<div id class="itle">
		<div class>
			<img :src="advertimages.imgurl" />
		</div>
		<div class="searchdiv clear">
			<input v-on:input="search_inp" class="search fl" id="myInputtext" v-model="bindkeytext" placeholder="输入名称可快速查找" value />
			<span class="bindsou" style="z-index:99999" @click="bindsou">
        <img src="../assets/s.png" />
      </span>
		</div>
		<div class="collect">
			<div class="collect_img" v-for="item in items">
				<div :style="'background: url('+item.imageurl+') center center no-repeat;background-size: contain;'" @click="coll(item.itemid)">

				</div>
			</div>
			<div class="ts" v-if="items==''">暂无您搜索的藏品</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: "PersonalCenter",
		data() {
			return {
				baseUrl: "",
				items: [],
				advertimages: [],
				bindkeytext: ""
			};
		},
		methods: {
			search_inp(){
				var that=this;
				if(that.bindkeytext==''){
					that.bindkeytext = "";
					that.article();
				}
			},
			coll(e) {
				var that = this;
				// sessionStorage.setItem("itemid", e);
				that.$router.push({
					name: "Collectionitem",
					query: {
						itemid: e
					}
				});
			},
			bindsou() {
				var that = this;
				var bindkeytext_reg = /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/;
				if(that.bindkeytext != "" && bindkeytext_reg.test(that.bindkeytext)) {
					wclient.view.showLoading();
					that.$http
						.get(
							that.baseUrl +
							"/ajax?ugi=item&action=search&moduleid=PORTAL&keyword=" +
							that.bindkeytext, {

							}
						)
						.then(function(res) {
							wclient.view.hideLoading();
							that.items = res.data.items;
						})
						.catch(function(err) {
							console.log(err);
						});
				} else {
					that.bindkeytext = "";
					that.article();
				}
			},
			advertPlacement() {
				var that = this;
				wclient.view.showLoading();
				that.$http
					.get(
						that.baseUrl + "/ajax?ugi=advertPlacement&action=selectAdvertPlacement&moduleid=PORTAL&apid=dd5131b079dc4e008d8f13e71f6ace8e", {}
					)
					.then(function(res) {
						wclient.view.hideLoading();
						that.advertimages = res.data.adverplacement.advertimages[0];
					})
					.catch(function(err) {
						console.log(err);
					});
			},
			article() {
				var that = this;
				wclient.view.showLoading();
				that.$http
					.get(
						that.baseUrl +
						"/exhibits/ajax?ugi=hall&action=itemlist&moduleid=PORTAL&hallid=85bc141e19a24772b886a2caf34615d8&page=1&pagesize=20", {}
					)
					.then(function(res) {
						wclient.view.hideLoading();
						that.items = res.data.items;
					})
					.catch(function(err) {
						console.log(err);
					});
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "https://www.xiangshan1949.cn";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "http://xs.weapi.org";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn";
			}
			that.baseUrl = baseUrl;
			wclient.view.showLoading();
			that.article();
			that.advertPlacement();
		}
	};
</script>

<style scoped>
	.ts {
		width: 100% !important;
		text-align: center;
		margin-top: 10%;
	}
	
	.bindsou {
		position: absolute;
		top: 10px;
		right: 9%;
	}
	
	.bindsou img {
		width: 20px;
	}
	
	.searchdiv {
		margin: 15px 0;
		position: relative;
	}
	
	.search {
		background: #f2f2f2;
		width: 82%;
		height: 40px;
		border-radius: 28px;
		font-size: 12px;
		margin-left: 5%;
		border: 0;
		padding-left: 8%;
		outline: none;
	}
	
	.collect {
		width: 92%;
		display: flex;
		justify-content: space-between;
		margin: 0 auto;
		flex-wrap: wrap;
	}
	.collect_img{
		width: 48%;
		background: white;
		margin-bottom: 10px;
		border-radius: 10px;
		overflow: hidden;
	}
	.collect_img div {
		width: 100%;
		height: 160px;
	}
</style>


// WEBPACK FOOTER //
// src/components/collection.vue